import { actionTypes } from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';

export const RebootGatewayAction = getApiActionCreator(actionTypes.REBOOT_GATEWAY_SETTINGS);

export const rebootGateway = (gatewayID) => {
    return {
        type: actionTypes.REBOOT_GATEWAY,
        gatewayID
    };
};

export const clearStore = () => {
    return {
        type: actionTypes.CLEAR_STORE
    };
};
